import { MDCTopAppBar } from '@material/top-app-bar'
import { MDCMenu, Corner } from '@material/menu'
import { MDCList } from '@material/list'
import { MDCDataTable } from '@material/data-table'
import { MDCCircularProgress } from '@material/circular-progress'
import { MDCDialog } from '@material/dialog'
import { MDCSelect } from '@material/select'
import { MDCRadio } from '@material/radio'
import { MDCCheckbox } from '@material/checkbox'
import { MDCSnackbar } from '@material/snackbar'
// eslint-disable-next-line no-unused-vars
import { MDCDrawer } from '@material/drawer'

import { MDCTooltip } from '@material/tooltip'

import * as JsBarcode from 'jsbarcode'

// timepicker
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'

import sortable from 'html5sortable/dist/html5sortable.es.js'

// Sortable
window.sortable = sortable

// FLATPICKER
window.flatpickr = flatpickr

// Firebase
const { firebaseConfig } = require('./firebaseConfig')

// eslint-disable-next-line no-undef
firebase.initializeApp(firebaseConfig)

// eslint-disable-next-line no-undef
firebase.auth().onAuthStateChanged(async function (user) {
  if (user) {
    const idToken = await user.getIdTokenResult()

    if (idToken.claims) {
      if (idToken.claims.workspace) {
        const workspace = idToken.claims.workspace
        // signed into workspace
        // eslint-disable-next-line no-undef
        const messagingRef = firebase.firestore().collection('workspaces').doc(workspace).collection('notifications')
        window.firebaseMessaging = {
          messagingRef
        }
      } else {
        // signed in but no workspace
        window.firebaseMessaging = false
      }
    }
  } else {
    window.firebaseMessaging = false
  }
})

window.JsBarcode = JsBarcode
window.mdc = {}

// DRAWER
if (document.querySelector('.mdc-drawer')) {
  const list = MDCList.attachTo(document.querySelector('.mdc-list'))
  list.wrapFocus = true
}

// CHECKBOX
window.mdc.Checkbox = MDCCheckbox

// SNACK
if (document.querySelector('.mdc-snackbar')) {
  // eslint-disable-next-line no-unused-vars
  const snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'))
  window.mdc.snackbar = snackbar
  const snacks = document.querySelectorAll('.mdc-snackbar__label')
  snackbar.timeoutMs = 5000
  if (snacks.length > 0) {
    snackbar.open()
  }
}

// RADIO
document.querySelectorAll('.mdc-radio').forEach(function (radEl) {
  // eslint-disable-next-line no-unused-vars
  const radio = new MDCRadio(radEl)
})

// TOOLTIP
window.mdc.Tooltip = MDCTooltip

// SELECT
window.mdc.selects = []
document.querySelectorAll('.mdc-select').forEach(function (selEl) {
  // eslint-disable-next-line no-unused-vars
  const select = new MDCSelect(selEl)
  window.mdc.selects.push(select)
  select.listen('MDCSelect:change', () => {
    try {
      // eslint-disable-next-line no-undef
      if (selectChange) {
        // eslint-disable-next-line no-undef
        selectChange(select)
      }
    } catch {
      // no callback
    }
  })
})

// DIALOG
window.mdc.MDCDialog = MDCDialog

// PROGRESS
document.querySelectorAll('.mdc-circular-progress').forEach(function (progCirc) {
  // eslint-disable-next-line no-unused-vars
  const circularProgress = new MDCCircularProgress(progCirc)
})

const topAppBarElement = document.querySelector('.mdc-top-app-bar')

// eslint-disable-next-line no-unused-vars
const topAppBar = new MDCTopAppBar(topAppBarElement)
const menuEl = document.querySelector('.mdc-menu-top')
if (menuEl) {
  const menu = new MDCMenu(menuEl)
  menu.setAnchorCorner(Corner.TOP_RIGHT)
  window.menuClick = function () {
    menu.open = true
  }
}

if (document.querySelector('.mdc-data-table')) {
  // eslint-disable-next-line no-unused-vars
  const dataTable = new MDCDataTable(document.querySelector('.mdc-data-table'))
  window.mdc.dataTable = dataTable
}

if (document.querySelector('.mdc-list')) {
  // eslint-disable-next-line no-unused-vars
  const list = new MDCList(document.querySelector('.mdc-list'))
}
